module.exports = __webpack_public_path__ + "static/linux-5f9d371286e4d163d5dba6653a0b65eb.svg";